import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['name', 'solution_type', 'category', 'form']
  static values = {
    event: String,
    props: String
  }

  submit(_e) {
    this.formTarget.requestSubmit()
  }

  reset(_e) {
    this.formTarget.reset()
    $('.selectpicker').selectpicker('refresh')
    this.formTarget.requestSubmit()
  }

  track(_e) {
    let properties = JSON.parse(this.propsValue)
    properties['searchTerm'] = this.nameTarget.value

    window.analytics?.track(this.eventValue, properties)
  }
}
